// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Vgpti","button":"styles_button__1NAEC","switch":"styles_switch__1Zy15","line":"styles_line__3OiYz","enabled":"styles_enabled__2JvHn"};